/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Mb } from './Mb';

class EnterpriseCooperation extends Mb {
    constructor() {
        super();
        this.baseUrl += '/enterpriseCooperation';
    }

    data({
        enterpriseSn,
        enterpriseName,
        enterpriseCooperationSn,
        enterpriseCooperationName,
        insertTime,
        writeOffEndTime,
        settlementTime,
        enterpriseCooperationStatus,
        schoolOrgId,
        cooperationApplyType,
        remarks,
        isShowNoRemarks,
        settlementRulesName,
        currentPage,
        pageSize,
    } = {}) {
        let insertBeginTime = null;
        let insertEndTime = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertBeginTime, insertEndTime] = insertTime;
        }
        let writeOffEndBeginTime = null;
        let writeOffEndEndTime = null;
        if (writeOffEndTime != null && writeOffEndTime.length === 2) {
            [writeOffEndBeginTime, writeOffEndEndTime] = writeOffEndTime;
        }
        let settlementBeginTime = null;
        let settlementEndTime = null;
        if (settlementTime != null && settlementTime.length === 2) {
            [settlementBeginTime, settlementEndTime] = settlementTime;
        }
        return super.get('/data', {
            enterpriseSn,
            enterpriseName,
            enterpriseCooperationSn,
            enterpriseCooperationName,
            insertBeginTime,
            insertEndTime,
            writeOffEndBeginTime,
            writeOffEndEndTime,
            settlementBeginTime,
            settlementEndTime,
            enterpriseCooperationStatus,
            schoolOrgId,
            cooperationApplyType,
            remarks,
            isShowNoRemarks,
            settlementRulesName,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { fileBasePath } = json.data.data;
            const { prepaidAttachment, settlementAttachment } = json.data.data.enterpriseCooperation;
            if (!prepaidAttachment) {
                json.data.data.enterpriseCooperation.prepaidAttachment = [];
            } else {
                json.data.data.enterpriseCooperation.prepaidAttachment = prepaidAttachment
                    .split(',')
                    .reduce((prev, curr) => {
                        prev.push({
                            name: curr,
                            address: fileBasePath + curr,
                        });
                        return prev;
                    }, []);
            }
            if (!settlementAttachment) {
                json.data.data.enterpriseCooperation.settlementAttachment = [];
            } else {
                json.data.data.enterpriseCooperation.settlementAttachment = settlementAttachment
                    .split(',')
                    .reduce((prev, curr) => {
                        prev.push({
                            name: curr,
                            address: fileBasePath + curr,
                        });
                        return prev;
                    }, []);
            }
            return json;
        });
    }

    save({
        id,
        enterpriseCooperationSn,
        enterpriseCooperationName,
        enterpriseId,
        orgId,
        settlementMethod,
        prepaidAmount,
        prepaidAttachment,
        writeOffEndTime,
        remarks,
        schoolOrgId,
        skuJson,
        enterpriseSettlementRulesId,
    } = {}) {
        const prepaidAttachmentStr = prepaidAttachment
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post(
            '/save',
            {
                id,
                enterpriseCooperationSn,
                enterpriseCooperationName,
                enterpriseId,
                orgId,
                settlementMethod,
                prepaidAmount,
                prepaidAttachment: prepaidAttachmentStr,
                writeOffEndTime,
                remarks,
                schoolOrgId,
                skuJson,
                enterpriseSettlementRulesId,
            },
            {
                isHandleError: true,
                timeout: 0,
            },
        );
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    select() {
        return super.get('/select', {});
    }

    settlement({ id, settlementAmount, settlementAttachment, settlementRemarks } = {}) {
        const settlementAttachmentStr = settlementAttachment
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/settlement', {
            id,
            settlementAmount,
            settlementAttachment: settlementAttachmentStr,
            settlementRemarks,
        });
    }

    saveSettlement({ id, settlementAmount, settlementAttachment, settlementRemarks } = {}) {
        const settlementAttachmentStr = settlementAttachment
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/saveSettlement', {
            id,
            settlementAmount,
            settlementAttachment: settlementAttachmentStr,
            settlementRemarks,
        });
    }

    submit({
        id,
        enterpriseCooperationStatus,
        auditOpinion,
        settlementMethod,
        prepaidAmount,
        prepaidAttachment,
        enterpriseCooperationName,
    }) {
        const prepaidAttachmentStr = prepaidAttachment
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/submit', {
            id,
            enterpriseCooperationStatus,
            auditOpinion,
            settlementMethod,
            prepaidAmount,
            prepaidAttachment: prepaidAttachmentStr,
            enterpriseCooperationName,
        });
    }

    saveRemarks({ id, remarks }) {
        return super.post('/saveRemarks', { id, remarks });
    }

    editEnterpriseSettlementRules({ enterpriseCooperationId, enterpriseSettlementRulesId }) {
        return super.post('/editEnterpriseSettlementRules', { enterpriseCooperationId, enterpriseSettlementRulesId });
    }
}

export default new EnterpriseCooperation();
export { EnterpriseCooperation };
